var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8662 1.8V1.80008L13.875 16.2C13.875 16.2 13.875 16.2001 13.875 16.2001M13.8662 1.8L0.516251 4.878C0.18375 5.211 0 5.67 0 6.147V16.2C0 17.19 0.7875 18 1.75 18H12.2588C13.2213 18 14 17.19 14 16.2L13.875 16.2001M13.8662 1.8C13.8662 0.874865 13.1394 0.125 12.25 0.125H5.97625C5.54657 0.125 5.13323 0.300071 4.83328 0.616933L4.83329 0.616941L4.83212 0.618135L0.605875 4.96513L0.605883 4.96514L0.604705 4.96632C0.296545 5.27494 0.125 5.70177 0.125 6.147V16.2C0.125 17.1243 0.859832 17.875 1.75 17.875H12.2588C13.1481 17.875 13.875 17.1252 13.875 16.2001M13.8662 1.8L13.875 16.2001M6.03538 1.26287L6.25 1.04211V1.35V5.4C6.25 5.96069 5.80358 6.425 5.25 6.425H1.3125H1.01663L1.22288 6.21286L6.03538 1.26287Z",
    fill: "url(#paint0_linear_4825_1456)",
    stroke: "url(#paint1_linear_4825_1456)",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15C6.5 15.2761 6.72386 15.5 7 15.5C7.27614 15.5 7.5 15.2761 7.5 15H6.5ZM7.35355 8.64645C7.15829 8.45118 6.84171 8.45118 6.64645 8.64645L3.46447 11.8284C3.2692 12.0237 3.2692 12.3403 3.46447 12.5355C3.65973 12.7308 3.97631 12.7308 4.17157 12.5355L7 9.70711L9.82843 12.5355C10.0237 12.7308 10.3403 12.7308 10.5355 12.5355C10.7308 12.3403 10.7308 12.0237 10.5355 11.8284L7.35355 8.64645ZM7.5 15L7.5 9H6.5L6.5 15H7.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4825_1456",
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0753EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4825_1456",
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0855EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39ABFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.5d6baa340e7faf7809b781c5b5c21855.svg";
export { ForwardRef as ReactComponent };